import { first } from 'lodash';
import React from 'react';

import Input from '../../../elements/forms/Input';

const SingleValueEnrichmentAnswer = props => {
    const {onChange, value} = props;
    return <Input {...props} value={first(value)} onChange={value => onChange([value])} />;
};

export default SingleValueEnrichmentAnswer;
